export default "__VITE_ASSET__B43jJxvH__"